var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EndScreen',{attrs:{"hasLargeMessage":_vm.extra_user_messages !== undefined && _vm.shop.discount_code !== undefined,"hasDiscountCode":_vm.shop.discount_code !== '',"confettiEnabled":_vm.shoot_confetti}},[_c('SuccessScreenContent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }